import { render } from "./event_adjustment_admin.vue?vue&type=template&id=5e20395a&scoped=true"
import script from "./event_adjustment_admin.vue?vue&type=script&lang=js"
export * from "./event_adjustment_admin.vue?vue&type=script&lang=js"

import "./event_adjustment_admin.vue?vue&type=style&index=0&id=5e20395a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e20395a"]])

export default __exports__